import ExamSettingsService from "@/common/api/exam-settings.service";
import { useAuthStore, useFeatureFlagsStore } from "@/stores";

export function useExamSettings() {
  const authStore = useAuthStore();
  const featureFlagsStore = useFeatureFlagsStore();

  const enableSearchAssistance = async () => {
    await ExamSettingsService.enableSearchAssistance();
    if (authStore.isAuthenticated) {
      await featureFlagsStore.refreshFeatureFlags();
    }
  };

  const enableForeignDictionaries = async () => {
    await ExamSettingsService.enableForeignDictionaries();
    if (authStore.isAuthenticated) {
      await authStore.loadUser();
    }
  };

  return {
    enableSearchAssistance,
    enableForeignDictionaries
  };
}
